import userRoles, {
  aprobador,
  consultaServicios,
  inspector,
  notificador,
  proveedorAdministrador,
  proveedorNotificador,
  referenteCompras,
  referenteControlGestion,
  responsableProyecto,
  solicitante
} from '../../security/constantsRols';
import { getUrlWithSessionCreds } from '../../utils/globalFunctions';
import { apiCertificationsApp } from '../../resources/environmentConstants';

/* eslint-disable consistent-return */
export const rolText = (rol) => {
  if (rol === 'ProveedorAdministrador') {
    return 'Proveedor Administrador';
  }
  if (rol === 'ProveedorNotificador') {
    return 'Proveedor Notificador';
  }
  if (rol === 'Notificador') {
    return 'Notificador';
  }
  if (rol === 'ConsultaServicios') {
    return 'Consulta Servicios';
  }
  if (rol === 'Aprobador') {
    return 'Aprobador';
  }
  if (rol === 'Solicitante') {
    return 'Solicitante';
  }
};

export const rolDuo = (rol) => {
  if (rol.includes('ProveedorAdministrador', 'ProveedorNotificador')) {
    return 'Prov. Administrador / Notificador';
  }
  if (rol.includes('SupervisorNotificador', 'Aprobador')) {
    return 'Notificador / Aprobador';
  }
  if (rol.includes('Solicitante', 'Aprobador')) {
    return 'Solicitante / Aprobador';
  }
};

export const rolUserMapper = (roles = []) => {
  const rolesUser = roles.map((rol) => {
    // Requester
    if (rol.includes(solicitante)) {
      return solicitante;
    }
    // Provider Admin.
    if (rol.includes(proveedorAdministrador)) {
      return proveedorAdministrador;
    }
    // Provider Notifier
    if (rol.includes(proveedorNotificador)) {
      return proveedorNotificador;
    }
    // Approver
    if (rol.includes(aprobador)) {
      return aprobador;
    }
    // Notifier
    if (rol.includes(notificador)) {
      return notificador;
    }
    // servicesConsultation
    if (rol.includes(consultaServicios)) {
      return consultaServicios;
    }
    // PEP Project Responsible
    if (rol.includes(responsableProyecto)) {
      return responsableProyecto;
    }
    // Management Control Contact
    if (rol.includes(referenteControlGestion)) {
      return referenteControlGestion;
    }
    // Referente Compras
    if (rol.includes(referenteCompras)) {
      return referenteCompras;
    }
    // Inspector
    if (rol.includes(inspector)) {
      return inspector;
    }

    return '';
  });

  return rolesUser.join('/');
};

const yClickLinks = () => [
  {
    id: 1,
    title: 'Solicitudes de Servicio',
    links: [
      {
        id: 12,
        url: '/createMultiple',
        callback: () => {},
        name: 'Crear nueva Solicitud',
        permissions: [userRoles.SOLICITANTE]
      },
      {
        id: 11,
        url: '/',
        callback: () => {},
        name: 'Consultar Bandeja de Solicitud de Servicio',
        permissions: [
          userRoles.INSPECTOR,
          userRoles.PROVEEDOR_ADMINISTRADOR,
          userRoles.PROVEEDOR_NOTIFICADOR,
          userRoles.USUARIO_CONSULTAS,
          userRoles.SOLICITANTE,
          userRoles.SUPERVISOR_NOTIFICADOR_YPF,
          userRoles.RESPONSABLE_PEP_PROYECTO,
          userRoles.GERENTE_COMPRA
        ]
      },
      {
        id: 15,
        url: '/manage-temp/workReport',
        callback: () => {},
        name: 'Administrar modelos de Solicitudes',
        permissions: [userRoles.PROVEEDOR_NOTIFICADOR, userRoles.SUPERVISOR_NOTIFICADOR_YPF]
      },
      {
        id: 16,
        url: '/manage-temp/request',
        callback: () => {},
        name: 'Administrar modelos de Solicitudes',
        permissions: [userRoles.SOLICITANTE]
      },
      {
        id: 13,
        url: '/create-asds',
        callback: () => {},
        name: 'Notificar Parte de Trabajo s/ Solicitud',
        permissions: [userRoles.PROVEEDOR_NOTIFICADOR, userRoles.SUPERVISOR_NOTIFICADOR_YPF]
      },
      {
        id: 14,
        url: '/approver',
        callback: () => {},
        name: 'Supervisar Partes de Trabajo',
        permissions: [userRoles.APROBADOR]
      }
    ]
  },
  {
    id: 2,
    title: 'Inspección y certificación',
    links: [
      {
        id: 21,
        url: getUrlWithSessionCreds(`${apiCertificationsApp}/#/inspeccion/resumen`),
        callback: () => {},
        name: 'Gestionar Autorizaciones',
        permissions: [userRoles.INSPECTOR]
      },
      {
        id: 22,
        url: getUrlWithSessionCreds(`${apiCertificationsApp}/#/errores/partes`),
        callback: () => {},
        name: 'Consultar Bandeja de Errores de Certificación',
        permissions: [
          userRoles.CONTROL_ERRORES_SAP,
          userRoles.RESPONSABLE_PEP_PROYECTO,
          userRoles.GERENTE_COMPRA,
          userRoles.USUARIO_CONSULTAS
        ]
      },
      {
        id: 23,
        url: getUrlWithSessionCreds(`${apiCertificationsApp}/#/habilitas`),
        callback: () => {},
        name: 'Consultar Bandeja de Habilitas',
        permissions: [
          userRoles.INSPECTOR,
          userRoles.PROVEEDOR_ADMINISTRADOR,
          userRoles.USUARIO_CONSULTAS
        ]
      }
    ]
  },
  {
    id: 3,
    title: 'Reportes',
    links: [
      {
        id: 31,
        url: getUrlWithSessionCreds(`${apiCertificationsApp}/#/reporte-certificacion`),
        callback: () => {},
        name: 'Generar Reporte de Trazabilidad',
        permissions: [
          userRoles.ADMINISTRADOR_CONTRATO,
          userRoles.INSPECTOR,
          userRoles.REFERENTE_CONTROL_GESTION,
          userRoles.CONTROL_ERRORES_SAP,
          userRoles.PROVEEDOR_ADMINISTRADOR,
          userRoles.PROVEEDOR_NOTIFICADOR,
          userRoles.USUARIO_CONSULTAS,
          userRoles.SOLICITANTE,
          userRoles.SUPERVISOR_NOTIFICADOR_YPF,
          userRoles.APROBADOR,
          userRoles.REFERENTE_COMPRAS,
          userRoles.RESPONSABLE_PEP_PROYECTO,
          userRoles.GERENTE_COMPRA
        ]
      },
      {
        /* El id:32 esta tomado por el reporte de trazabilidad */
        id: 33,
        url: '/reporte-provision',
        callback: () => {},
        name: 'Generar Reporte de Provisión',
        permissions: [userRoles.INSPECTOR, userRoles.REFERENTE_CONTROL_GESTION]
      }
    ]
  },
  {
    id: 4,
    title: 'Administración',
    links: [
      {
        id: 41,
        url: getUrlWithSessionCreds(`${apiCertificationsApp}/#/contratos`),
        callback: () => {},
        name: 'Configurar Contratos',
        permissions: [userRoles.ADMINISTRADOR_CONTRATO, userRoles.INSPECTOR]
      },
      {
        id: 42,
        url: getUrlWithSessionCreds(`${apiCertificationsApp}/#/cuenta-contable`),
        callback: () => {},
        name: 'Configurar Cuenta Contable',
        permissions: [userRoles.REFERENTE_CONTROL_GESTION, userRoles.USUARIO_CONSULTAS]
      },
      {
        id: 43,
        url: getUrlWithSessionCreds(`${apiCertificationsApp}/#/ordenes-internas`),
        callback: () => {},
        name: 'Clasificar Órdenes Internas',
        permissions: [userRoles.REFERENTE_CONTROL_GESTION, userRoles.USUARIO_CONSULTAS]
      }
    ]
  }
];

// devuelve un array filtrado de links respecto a un array de roles/permisos
const verifyLinkPermissions = (linksArray, roles) =>
  linksArray.filter((l) => roles.some((r) => l.permissions.includes(r.nombre)));

// returns the yClickLinks array filtered by roles/permissions
export const getAllowedLinks = (rolesArray) => {
  // if roles do not exist
  if (!Array.isArray(rolesArray) || (Array.isArray(rolesArray) && !rolesArray.length)) return [];

  // rolesArray = [{ id: 1, nombre: 'Admin'}, {id: 2, nombre: 'Insp'}, ...]
  // map the user's role(s)

  const returnedLinks = [];

  yClickLinks().forEach((yClickLink) => {
    // retrieve links of each section, filtered by roles/permissions
    const links = verifyLinkPermissions(yClickLink.links, rolesArray);

    // verify that there is at least 1 item in the array
    // to push it to the array returned by the function
    if (links.length > 0) {
      returnedLinks.push({
        id: yClickLink.id,
        title: yClickLink.title,
        links
      });
    }
  });

  return returnedLinks;
};
